import { render, staticRenderFns } from "./list.vue?vue&type=template&id=12d277ba&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style1 from "./list.vue?vue&type=style&index=1&id=12d277ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d277ba",
  null
  
)

export default component.exports